export default function openBase64InNewTab(data) {
  var newTab = window.open();
  newTab.document.body.innerHTML = `<div style="widht:100%; height: 100%; padding: 0; margin: 0;"><img style="object-fit: contain; width: 100%; height: 100%" src="${data}"><div>`;
}
